export default {
  setVeiculos({ commit }, payload) {
    commit("setVeiculos", payload)
  }
}
